var _defs, _rect, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwsCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "AWS development",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232f3e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 64,
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 298c-30 0-54-22-54-50 0-24 18-44 42-49 10-46 54-81 107-81 54 0 99 34 109 82 22 7 38 27 38 50 0 29-25 52-56 52H164z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 380,
    textAnchor: "middle",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial",
    fontSize: 64,
    fontWeight: 700,
    fill: "#ffffff"
  }, "\n    AWS DEV\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCloud);
export default __webpack_public_path__ + "static/media/aws_cloud.542d7468f3dfc97711a5b26bb9850190.svg";
export { ForwardRef as ReactComponent };